<template>
  <div>
    <!-- 设置页banner -->
    <div class="MerchantsDaybox">
      <div class="icon_box">
        <img :src="$OSS + 'MerchantsDay_laba.png'" alt="" />
      </div>
      <NoticeBar
        v-if="NoticeBarShow"
        class="banner"
        color="#FF5700"
        background="#FFECE2"
        speed="50"
        :text="banner_text"
      />
      <div class="button_box">
        <div @click="jump_link" class="button">立即续费</div>
      </div>
    </div>
  </div>
</template>
<script>
import { NoticeBar, Toast } from "vant";
import { URL5,URL6 } from "@/utils/Redirect";
import { mapState } from "vuex";

export default {
  name: "MerchantsDay20210312",
  components: {
    NoticeBar,
    Toast
  },
  data() {
    return {
      BannerImage: "SpecialDiscount_banner8.png",
      banner_text:"高效客服管理工具特惠福利 最高折扣再8折！另每月赠送200条短信+50分钟通话，提高店铺排名点击获取福利优惠＞＞",
      BannerTips: "",
      Link: "",
      NoticeBarShow: true,
    };
  },
  computed: {
    ...mapState({
      UserInfo: (state) => {
        return state.Public.UserInfo;
      },
    }),
  },
  mounted(){
    if(this.UserInfo.serv_jump == 0 ){
      this.Link = URL5
      // this.BannerImage = 'SpecialDiscount_banner8.png'
    }else{
      this.Link = URL6
      // let TotalNumber = 150;
      // this.BannerTips = `免费试用接收消息已消耗：${20}条，剩余${TotalNumber-20}条`
      // this.BannerImage = 'SpecialDiscount_banner9.png'
    }
    window.addEventListener("pageshow",()=>{
        this.NoticeBarShow=false
        setTimeout(()=>{
          this.NoticeBarShow=true
        },10)
    },false)
  },
  methods: {
    jump_link() {
      
      this.$store.dispatch("Public/renew", {}).then(res=>{
        if(res.code == 1000) {
          this.inH5Record()
        }else {
          Toast(res.message)
        }
      });
      
    },
    inH5Record() {
      let data = {
        page_from: "main_page",
        page_name: this.$route.name,
        page_time: "0.00",
        btn_name: "立即续费",
        receiver_id: "",
        page_param: { btn_name: "renew_button" },
      };
      this.$store.dispatch("Public/inH5Record", data).then(res=>{
        window.location.href=this.Link
      });
    }
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>